export var breakpoints = {
  xs: '320px',
  sm: '567px',
  md: '768px',
  lg: '992px',
  xl: '1200px'
};

var generateMediaQueries = function generateMediaQueries(points) {
  return {
    xs: "@media (min-width: ".concat(points.xs, ")"),
    sm: "@media (min-width: ".concat(points.sm, ")"),
    md: "@media (min-width: ".concat(points.md, ")"),
    lg: "@media (min-width: ".concat(points.lg, ")"),
    xl: "@media (min-width: ".concat(points.xl, ")"),
    hover: '@media (hover: hover)'
  };
};

export { generateMediaQueries };